export const MAX_PAGE_SIZE = 100;
// ---------------------------------------------------------------------------
// Enumerations
// ---------------------------------------------------------------------------
export const BUSINESS_STATUSES = ['active', 'onboarding', 'suspended', 'inactive'];
export const BRANCH_TYPES = ['main', 'secondary', 'warehouse'];
export const BRANCH_STATUSES = ['active', 'inactive'];
export const ADMIN_USER_STATUSES = ['active', 'inactive'];
export const DEVICE_SETUP_MODES = ['connect_later', 'link_existing'];
export const PLANNED_LICENSE_TYPES = ['annual', 'monthly', 'perpetual', 'trial'];
export const LICENSE_DURATION_KEYS = ['m1', 'm3', 'm6', 'm12', 'm24', 'm36', 'd14', 'd30'];
export const LICENSE_DURATIONS_BY_TYPE = {
    annual: ['m12', 'm24', 'm36'],
    monthly: ['m1', 'm3', 'm6'],
    trial: ['d14', 'd30'],
    perpetual: [],
};
// ---------------------------------------------------------------------------
// Business master record
// ---------------------------------------------------------------------------
const CODE_PREFIX = {
    PHARMACY: 'PH',
    SUPERMARKET: 'SM',
    RESTAURANT: 'RS',
    OTHER: 'BZ',
};
/** Human-readable business reference, e.g. `PH-00012`. */
export function formatBusinessCode(category, number) {
    return `${CODE_PREFIX[category]}-${String(number).padStart(5, '0')}`;
}
export const PHARMACY_SORT_KEYS = ['name', 'country', 'status', 'createdAt', 'code'];
export const PASSWORD_MIN_LENGTH = 12;
export const PASSWORD_MAX_LENGTH = 128;
//# sourceMappingURL=domain.js.map